var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _objectSpread = require("/node_modules/@babel/runtime/helpers/objectSpread");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('axios'), require('logrocket')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'axios', 'logrocket'], factory) : (global = global || self, factory(global.tracker = {}, global.React, global.PropTypes, global.Axios, global.Logrocket));
})(this, function (exports, React, PropTypes, axios$1, LogRocket$1) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  var PropTypes__default = 'default' in PropTypes ? PropTypes['default'] : PropTypes;
  axios$1 = axios$1 && Object.prototype.hasOwnProperty.call(axios$1, 'default') ? axios$1['default'] : axios$1;
  LogRocket$1 = LogRocket$1 && Object.prototype.hasOwnProperty.call(LogRocket$1, 'default') ? LogRocket$1['default'] : LogRocket$1;
  /* eslint-disable no-console */

  var categoryKeys = {
    signin: ['category', 'action', 'hybrid_nonhybrid'],
    energy: ['category', 'campaign_type', 'action', 'internal_external', 'state', 'fuel_type', 'solar_nonsolar', 'existing_customer'],
    car: ['category', 'campaign_type', 'action', 'renewal_month'],
    home: ['category', 'campaign_type', 'action', 'renewal_month'],
    broadband: ['category', 'campaign_type', 'action', 'existing_customer'],
    mobile: ['category', 'campaign_type', 'action', 'existing_customer'],
    genericEnergy: ['category', 'campaign_type', 'action', 'existing_customer'],
    generic: ['category', 'campaign_type', 'action', 'existing_customer', 'offer_type'],
    health: ['category', 'campaign_type', 'action', 'family_type'],
    default: ['category', 'campaign_type', 'action', 'offer_type'],
    'dashboard-preferences': ['category', 'action', 'products']
  };
  var optionalKeys = {
    signin: [],
    energy: ['campaign_type', 'solar_nonsolar', 'internal_external', 'existing_customer', 'fuel_type'],
    generic: ['campaign_type', 'existing_customer', 'offer_type'],
    genericEnergy: ['campaign_type', 'existing_customer'],
    home: ['campaign_type', 'renewal_month'],
    car: ['campaign_type', 'renewal_month'],
    broadband: ['campaign_type', 'existing_customer'],
    mobile: ['campaign_type', 'existing_customer'],
    health: ['campaign_type', 'family_type'],
    'dashboard-preferences': ['products']
  };

  var getTrackingValues = function getTrackingValues(keys, tracking) {
    var requiredOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (requiredOnly) {
      keys = keys.filter(function (e) {
        return !getOptionalKeys(tracking.category).includes(e);
      });
    }

    return keys.map(function (key) {
      return tracking[key] || tracking.meta && tracking.meta[key] || undefined;
    });
  };

  var energyTrackingValues = function energyTrackingValues(keys, tracking) {
    var fuelTypes = {
      E: 'Electricity',
      EG: 'DualFuel',
      G: 'Gas'
    };
    var solarValue = typeof tracking.meta.is_solar === 'boolean' ? tracking.meta.is_solar ? 'solar' : 'nonsolar' : undefined;

    var energyTracking = _objectSpread({}, tracking, {
      fuel_type: fuelTypes[tracking.meta.plan_type] || undefined,
      solar_nonsolar: solarValue
    });

    return getTrackingValues(keys, energyTracking);
  };

  var getValuesMap = {
    energy: energyTrackingValues,
    generic: getTrackingValues
  };

  var getValues = function getValues(keys, tracking) {
    var requiredOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // FIXME: energy presignup hybrid doesn't have plan's info cause not match required values of energy category
    if (tracking.category === 'energy' && (tracking.action === 'presignup' || tracking.action === 'preoffer' || tracking.action === 'signin' || tracking.page === 'landing_page')) {
      return getTrackingValues(categoryKeys.genericEnergy, tracking, requiredOnly);
    }

    var getValuesFunc = getValuesMap[tracking.category] || getValuesMap.generic;
    return getValuesFunc(keys, tracking);
  };

  var getKeys = function getKeys(category) {
    return categoryKeys[category] || categoryKeys.generic;
  };

  var reformatDefault = function reformatDefault(keys, values, meta) {
    var categoryIndex = keys.indexOf('category');

    if (categoryIndex === -1) {
      return values;
    } else if (!meta || !meta.defaultProduct) {
      return values;
    } else {
      values[categoryIndex] = meta.defaultProduct;
      return values;
    }
  };

  var getOptionalKeys = function getOptionalKeys(category) {
    return optionalKeys[category] || optionalKeys.generic;
  };

  var Google =
  /*#__PURE__*/
  function () {
    function Google() {
      _classCallCheck(this, Google);
    }

    _createClass(Google, null, [{
      key: "sendData",
      value: function sendData(tracking) {
        var keys = getKeys(tracking.category);
        var values = getValues(keys, tracking);
        var requiredKeys = keys.filter(function (e) {
          return !getOptionalKeys(tracking.category).includes(e);
        });
        var requiredValues = getValues(requiredKeys, tracking, true);

        if (!requiredValues.every(function (value) {
          return value && value !== '';
        }) && process.env.NODE_ENV !== 'test') {
          console.log('Missing keys for google analytics pageview');
        } else {
          if (tracking.category === 'default') {
            values = reformatDefault(keys, values, tracking.meta);
          } // Remove empty or null values in the eventPath


          var eventPath = values.filter(function (e) {
            return e && e !== '';
          }).join('/');
          console.log('GOOGLE EventPath: ', eventPath);

          if (typeof window.ga === 'function') {
            window.ga('send', {
              hitType: 'pageview',
              page: "virtual/".concat(eventPath)
            });
          }
        }
      }
    }]);

    return Google;
  }();

  var sendToConversionAPI =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(tracking, fullEventPath) {
      var fbpValue, conversionUrl, pixelId, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('sendToConversionAPI data ', tracking);
              fbpValue = getFbClientId();
              conversionUrl = window.facebook_conversion_url;
              pixelId = window.facebook_pixel_id;

              if (!(pixelId && conversionUrl)) {
                _context.next = 11;
                break;
              }

              _context.next = 7;
              return axios$1.post(conversionUrl, {
                event_name: fullEventPath,
                email: tracking.meta.email,
                postcode: tracking.meta.postcode,
                state: tracking.meta.state,
                pixel_id: pixelId,
                fbp: fbpValue,
                category: tracking.category,
                plan_type: tracking.meta.plan_type,
                tracking_id: tracking.meta.tracking_id
              }).then(function (response) {
                return response.data;
              }).catch(function (ex) {
                console.error(ex);
                return false;
              });

            case 7:
              result = _context.sent;
              return _context.abrupt("return", result);

            case 11:
              return _context.abrupt("return", false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendToConversionAPI(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  function getFbClientId() {
    var result = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);

    if (!(result && result[1])) {
      return null;
    }

    return result[1];
  }
  /* eslint-disable no-console */
  // import Cookies from 'universal-cookie';
  // const cookies = new Cookies();
  // const setCookie = name => {
  //   const expires = new Date();
  //   expires.setMinutes(expires.getMinutes() + 5);
  //   cookies.set(name, true, {
  //     expires,
  //   });
  // };


  var trackCustomEvent = function trackCustomEvent(eventName, data) {
    // const eventCookieName = `${eventName}-facebook-pixel-${data.tracking_id}`;
    if (window.fbq) {
      // if (!cookies.get(eventCookieName)) {
      window.fbq('trackCustom', eventName, data); // setCookie(eventCookieName);
      // }
    }
  };

  var actionMap = {
    get_started: 'getStarted',
    signin: 'SignUp' // keeping this as SingUp for tracking purposes

  };

  var genericPlanKeys = function genericPlanKeys(tracking) {
    return {
      action: tracking.action,
      tracking_id: tracking.meta && tracking.meta.tracking_id,
      merchant_name: tracking.meta && tracking.meta.merchant_name,
      product: tracking.category
    };
  };

  var energyPlanKeys = function energyPlanKeys(tracking) {
    return _objectSpread({}, genericPlanKeys(tracking), {
      state: tracking.meta && tracking.meta.state,
      plan_type: tracking.meta && tracking.meta.plan_type,
      is_solar: tracking.meta && tracking.meta.solar_nonsolar
    });
  };

  var categoryKeys$1 = {
    energy: energyPlanKeys,
    generic: genericPlanKeys
  }; // TODO: Extract this to a util function

  var filterObject = function filterObject(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
      var _acc = acc;
      if (obj[key] !== undefined) _acc[key] = obj[key];
      return _acc;
    }, {});
  };

  var chooseCategoryKeys = function chooseCategoryKeys(category) {
    return categoryKeys$1[category] || categoryKeys$1.generic;
  };

  var Facebook =
  /*#__PURE__*/
  function () {
    function Facebook() {
      _classCallCheck(this, Facebook);
    }

    _createClass(Facebook, null, [{
      key: "sendData",
      value: function () {
        var _sendData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(tracking) {
          var categoryKeys, keys, values, requiredKeys, requiredValues, eventPath;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  categoryKeys = chooseCategoryKeys(tracking.category);
                  keys = getKeys(tracking.category);
                  values = getValues(keys, tracking);

                  if (tracking.category === 'default') {
                    values = reformatDefault(keys, values, tracking.meta);
                    tracking.category = tracking.meta && tracking.meta.defaultProduct ? tracking.meta.defaultProduct : 'default';
                  }

                  trackCustomEvent(actionMap[tracking.action] || tracking.action, filterObject(categoryKeys(tracking)));
                  requiredKeys = keys.filter(function (e) {
                    return !getOptionalKeys(tracking.category).includes(e);
                  });
                  requiredValues = getValues(requiredKeys, tracking, true);

                  if (!(!requiredValues.every(function (value) {
                    return value && value !== '';
                  }) && process.env.NODE_ENV !== 'test')) {
                    _context2.next = 11;
                    break;
                  }

                  console.log('Missing keys for facebook conversion event');
                  _context2.next = 15;
                  break;

                case 11:
                  // Remove empty or null values in the eventPath
                  eventPath = values.filter(function (e) {
                    return e && e !== '';
                  }).join('/');
                  console.log('FACEBOOK EventPath: ', eventPath);
                  _context2.next = 15;
                  return sendToConversionAPI(tracking, "virtual/".concat(eventPath));

                case 15:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function sendData(_x3) {
          return _sendData.apply(this, arguments);
        }

        return sendData;
      }()
    }]);

    return Facebook;
  }();

  var axios = require('axios');

  var LogRocket = require('logrocket');

  var sendDataToServer = function sendDataToServer(data, authenticityToken) {
    var config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken
      }
    };
    axios.post('/ajax/funnel-report/track-step', data, config).catch(function (error) {
      LogRocket.captureException(error, {
        tags: {
          service: 'funnel'
        }
      });
    });
  };

  var defaultCategoryKeys = function defaultCategoryKeys() {
    var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return {
      get_started: function get_started(tracking) {
        return {
          step_code: "".concat(category.replace(/-/g, '_'), "_click_get_started"),
          plan_id: tracking.meta.tracking_id,
          product: "".concat(category.replace(/-/g, '_')),
          get_started: true
        };
      }
    };
  }; // Returns a key value pairs that we will send to the server
  // step_code: the funnel step code
  // plan_id: can be the id of the plan, campaign, etc. (this is a bit confusing, doule check in rails funnel_report_controller)
  // product: product mapped to the user profile (e.g life = life_insurance_profile in the server)
  // get_started: whether we want to record the last get started event or not


  var categoryKeys$2 = {
    'life-insurance': {
      get_quote: function get_quote(tracking) {
        return {
          step_code: 'life_get_a_quote_page',
          plan_id: tracking.meta.tracking_id,
          product: 'life',
          get_started: true
        };
      },
      call_me_back: function call_me_back(tracking) {
        return {
          step_code: 'life_submit_call_me_back_page',
          plan_id: tracking.meta.tracking_id,
          product: 'life',
          get_started: false
        };
      }
    },
    energy: {
      get_started: function get_started(tracking) {
        if (tracking.meta.internal_external === 'external') {
          // FIXME: for now we are just adding 'click_get_started' as our
          // funnel reporting doesn't know any different.
          return {
            step_code: 'click_get_started',
            plan_id: tracking.meta.tracking_id,
            product: 'energy',
            get_started: true
          };
        }

        return {
          step_code: 'click_get_started',
          plan_id: tracking.meta.tracking_id,
          product: 'energy',
          get_started: true
        };
      },
      switch_confirm: function switch_confirm(tracking) {
        return {
          step_code: 'energy_click_switch_confirm',
          plan_id: tracking.meta.tracking_id,
          product: 'energy',
          get_started: false
        };
      }
    },
    'health-insurance': {
      get_started: function get_started(tracking) {
        return {
          step_code: 'health_click_get_started',
          plan_id: tracking.meta.tracking_id,
          product: 'health',
          get_started: true
        };
      }
    },
    'car-insurance': {
      get_started: function get_started(tracking) {
        return {
          step_code: 'car_click_get_started',
          plan_id: tracking.meta.tracking_id,
          product: 'car',
          get_started: true
        };
      }
    },
    'home-and-contents-insurance': {
      get_started: function get_started(tracking) {
        return {
          step_code: 'home_and_contents_click_get_started',
          plan_id: tracking.meta.tracking_id,
          product: 'home',
          get_started: true
        };
      }
    }
  };

  var Funnel =
  /*#__PURE__*/
  function () {
    function Funnel() {
      _classCallCheck(this, Funnel);
    }

    _createClass(Funnel, null, [{
      key: "sendData",
      value: function sendData(tracking) {
        var categoryKey = categoryKeys$2[tracking.category] || defaultCategoryKeys(tracking.category);

        if (categoryKey !== undefined) {
          var actionKey = categoryKey[tracking.action];

          if (actionKey !== undefined) {
            var authenticityToken = tracking.authenticityToken;
            var data = actionKey(tracking);
            sendDataToServer(data, authenticityToken);
          }
        }
      }
    }]);

    return Funnel;
  }();

  var Twitter =
  /*#__PURE__*/
  function () {
    function Twitter() {
      _classCallCheck(this, Twitter);
    }

    _createClass(Twitter, null, [{
      key: "sendData",
      value: function sendData(tracking) {
        var keys = getKeys(tracking.category);
        var values = getValues(keys, tracking);
        var requiredKeys = keys.filter(function (e) {
          return !getOptionalKeys(tracking.category).includes(e);
        });
        var requiredValues = getValues(requiredKeys, tracking, true);

        if (!requiredValues.every(function (value) {
          return value && value !== '';
        }) && process.env.NODE_ENV !== 'test') {
          console.log('Missing keys for twitter analytics pageview');
        } else {
          if (tracking.category === 'default') {
            values = reformatDefault(keys, values, tracking.meta);
          } // Remove empty or null values in the eventPath


          var eventPath = values.filter(function (e) {
            return e && e !== '';
          }).join('/');
          console.log('TWITTER EventPath: ', eventPath);

          if (typeof window.twq === 'function') {
            window.twq('track', 'PageView', {
              page: "virtual/".concat(eventPath)
            });
          }
        }
      }
    }]);

    return Twitter;
  }();

  var Bing =
  /*#__PURE__*/
  function () {
    function Bing() {
      _classCallCheck(this, Bing);
    }

    _createClass(Bing, null, [{
      key: "sendData",
      value: function sendData(tracking) {
        var keys = getKeys(tracking.category);
        var values = getValues(keys, tracking);
        var requiredKeys = keys.filter(function (e) {
          return !getOptionalKeys(tracking.category).includes(e);
        });
        var requiredValues = getValues(requiredKeys, tracking, true);

        if (!requiredValues.every(function (value) {
          return value && value !== '';
        })) {
          LogRocket$1.captureException('Missing keys for Bing Analytics UET page_view', {
            tags: {
              service: 'uet'
            }
          });
        } else {
          if (tracking.category === 'default') {
            values = reformatDefault(keys, values, tracking.meta);
          }

          var eventPath = values.filter(function (e) {
            return e && e !== '';
          }).join('/');
          console.log('BING EventPath: ', eventPath);

          if (window.uetq) {
            window.uetq.push('event', 'page_view', {
              page_path: "/virtual/".concat(eventPath)
            });
          }
        }
      }
    }]);

    return Bing;
  }();
  /* eslint-disable no-template-curly-in-string */


  var safeSendTo = function safeSendTo(service, data) {
    try {
      service.sendData(data);
    } catch (error) {
      console.log(error);
    }
  };

  var track = function track(action, trackingData) {
    var data = _objectSpread({}, trackingData, {
      action: action
    });

    safeSendTo(Google, data);
    safeSendTo(Facebook, data);
    safeSendTo(Funnel, data);
    safeSendTo(Bing, data);
    safeSendTo(Twitter, data);
  };

  var _trackEvent = function trackEvent(e, action, trackingData, callback) {
    track(action, trackingData);

    if (typeof callback === 'function') {
      callback(e);
    }
  };

  var TrackingContext =
  /*#__PURE__*/
  React.createContext({
    trackingData: {},
    trackEvent: _trackEvent
  });

  var mungeHref = function mungeHref(url) {
    try {
      var parsedUrl = new URL(url);
      return "".concat(parsedUrl.hostname).concat(parsedUrl.pathname.replace(/\//g, '---'));
    } catch (e) {// console.error(e);
    }
  };

  var useTracker = function useTracker() {
    var _React$useContext = React.useContext(TrackingContext),
        trackingData = _React$useContext.trackingData;

    return {
      trackEvent: function trackEvent(e, action, callback) {
        var realAction = action;
        var aTag = e && e.target.closest('a'); // If we don't receive an action, grab the href out of the
        // DOM node and clean it up so it can be sent as a virtual page view

        if (aTag && aTag.href && !action) {
          realAction = mungeHref(aTag.href);
          console.log(realAction);
        }

        _trackEvent(e, realAction, trackingData, callback);
      }
    };
  };

  var TrackingProvider = function TrackingProvider(_ref2) {
    var children = _ref2.children,
        trackEventOverride = _ref2.trackEventOverride,
        trackingData = _ref2.trackingData;

    /* istanbul ignore next */
    var realTrackEvent = trackEventOverride || _trackEvent;
    return (
      /*#__PURE__*/
      React.createElement(TrackingContext.Provider, {
        value: {
          trackingData: trackingData,
          trackEvent: realTrackEvent
        }
      }, children)
    );
  };

  var TrackerRegistration =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TrackerRegistration, _React$Component);

    function TrackerRegistration() {
      _classCallCheck(this, TrackerRegistration);

      return _possibleConstructorReturn(this, _getPrototypeOf(TrackerRegistration).apply(this, arguments));
    }

    _createClass(TrackerRegistration, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Twitter Business Conversion tracking
        if (this.props.twitter_analytics_id) {
          var twitter_tracker = document.createElement('script');
          twitter_tracker.innerHTML = "!(function(e, t, n, s, u, a) {\n        e.twq ||\n          ((s = e.twq = function() {\n            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);\n          }),\n          (s.version = '1.1'),\n          (s.queue = []),\n          (u = t.createElement(n)),\n          (u.async = !0),\n          (u.src = '//static.ads-twitter.com/uwt.js'),\n          (a = t.getElementsByTagName(n)[0]),\n          a.parentNode.insertBefore(u, a));\n      })(window, document, 'script');\n      twq('init', '".concat(this.props.twitter_analytics_id, "');");
          this.instance.appendChild(twitter_tracker);
        } // Google Tag Manager


        if (this.props.google_tag_mgr_id) {
          var gtag_mgr = document.createElement('script');
          gtag_mgr.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','".concat(this.props.google_tag_mgr_id, "');");
          this.instance.appendChild(gtag_mgr);
        } // Google Optimize Code starts


        if (this.props.google_optimize_id) {
          var g_optimze = document.createElement('script');
          var c_css = document.createElement('style');
          c_css.innerHTML = ".async-hide {opacity: 0 !important}"; // Anti - flicker snippet(recommended)

          var g_optimze_html = "(function(a,s,y,n,c,h,i,d,e){s.className += ' ' + y;h.start=1*new Date;\n      h.end=i=function(){s.className = s.className.replace(RegExp(' ?' + y), '')};\n      (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;\n      })(window,document.documentElement,'async-hide','dataLayer',4000,\n      {'".concat(this.props.google_optimize_id, "':true});");
          g_optimze.innerHTML = g_optimze_html;
          this.instance.appendChild(g_optimze);
          var g_optimize_source = document.createElement('script');
          g_optimize_source.src = "https://www.googleoptimize.com/optimize.js?id=".concat(this.props.google_optimize_id);
          g_optimize_source.setAttribute('onerror', "dataLayer.hide.end && dataLayer.hide.end()");
          this.instance.appendChild(c_css);
          this.instance.appendChild(g_optimize_source); // Google Optimize Code ends
        } //FOR GOOGLE ANALYTICS


        if (this.props.ga_code) {
          var googleAnalytics = document.createElement('script');
          googleAnalytics.type = 'text/javascript';
          googleAnalytics.innerHTML = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){" + '(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),' + 'm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)' + "})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');" + "ga('create', '" + "".concat(this.props.ga_code) + "', 'auto');" + "ga('send', 'pageview');";
          this.instance.appendChild(googleAnalytics);
        }

        if (this.props.bing_uet_tag_code) {
          //FOR BING
          var bing = document.createElement('script');
          bing.type = 'text/javascript';
          bing.innerHTML = '(function (w, d, t, r, u) { ' + 'var f, n, i;' + 'w[u] = w[u] || [], f = function () {' + " var o = {ti: '" + "".concat(this.props.bing_uet_tag_code) + "'};" + ' o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")' + ' }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {' + ' var s = this.readyState;' + ' s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)' + '}, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)' + '})(window, document, "script", "//bat.bing.com/bat.js", "uetq");' + 'window.uetq = window.uetq || [];' + " window.uetq.push ('event', 'pageview');";
          this.instance.appendChild(bing);
        }

        if (this.props.google_adwords_id) {
          //FOR GOOGLE ADWORDS
          var adwords1 = document.createElement('script');
          adwords1.async = true;
          adwords1.src = "https://www.googletagmanager.com/gtag/js?id='" + "".concat(this.props.google_adwords_id) + "'";
          this.instance.appendChild(adwords1);
        }

        if (this.props.google_adwords_id) {
          var adwords2 = document.createElement('script');
          adwords2.innerHTML = 'window.dataLayer = window.dataLayer || [];' + 'function gtag() {' + 'dataLayer.push(arguments);' + '}' + "gtag('js', new Date());" + "gtag('config', '" + "".concat(this.props.google_adwords_id) + "');";
          this.instance.appendChild(adwords2);
        }

        if (this.props.fullstory_id) {
          var fullstory = document.createElement('script');
          fullstory.innerHTML = "\n      window['_fs_host'] = 'fullstory.com';\n      window['_fs_org'] = '".concat(this.props.fullstory_id, "';\n      window['_fs_namespace'] = 'FS';\n      (function(m,n,e,t,l,o,g,y){\n          if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n          g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n          o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_host+'/s/fs.js';\n          y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);\n          g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n          g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n          g.log = function(a,b) { g(\"log\", [a,b]) };\n          g.consent=function(a){g(\"consent\",!arguments.length||a)};\n          g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n          g.clearUserCookie=function(){};\n      })(window,document,window['_fs_namespace'],'script','user');\n    ");
          this.instance.appendChild(fullstory);
        }

        if (this.props.facebook_pixel_id) {
          //FOR FACEBOOK CONVERSION API
          window.facebook_pixel_id = this.props.facebook_pixel_id; //FOR FACEBOOK PIXEL

          var fb1 = document.createElement('script');
          fb1.innerHTML = '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?' + 'n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;' + "n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;" + 't.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,' + "document,'script','https://connect.facebook.net/en_US/fbevents.js');" + "fbq('init', '" + "".concat(this.props.facebook_pixel_id) + "');" + "fbq('track', 'PageView');";
          this.instance.appendChild(fb1);
        }

        if (this.props.facebook_conversion_url) {
          window.facebook_conversion_url = this.props.facebook_conversion_url;
        }

        if (this.props.enable_trustpilot_js_script) {
          var tpilot = document.createElement('script');
          tpilot.type = 'text/javascript';
          tpilot.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
          tpilot.async = true;
          this.instance.appendChild(tpilot);
        }

        if (this.props.zendesk_id) {
          //FOR ZENDESK
          var zd1 = document.createElement('script');
          zd1.type = 'text/javascript';
          zd1.innerHTML = "window.zESettings = {webWidget: {contactOptions: { enabled: true, contactButton: { '*': 'Contact Button' }, chatLabelOnline: { '*': 'Live Chat' },    chatLabelOffline: { '*': 'Chat is unavailable' },  contactFormLabel: { '*': 'Leave us a message' } } } };";
          this.instance.appendChild(zd1);
          var zd2 = document.createElement('script');
          zd2.id = 'ze-snippet';
          zd2.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(this.props.zendesk_id);
          zd2.defer = true;
          this.instance.appendChild(zd2);
        }

        if (this.props.sfmc_business_account_id) {
          // SalesForce Marketting Cloud Collect code
          var sfmc = document.createElement('script');
          var sfmc_script_html = "(function (n, i, r, o, j, s, p) {\n      s = i.createElement(r),p = i.getElementsByTagName(r)[0];\n      s.async = 1;s.src = o;p.parentNode.insertBefore(s, p);\n      s.onload = s.onreadystatechange = function () {\n      _etmc.push(['setOrgId', '".concat(this.props.sfmc_business_account_id, "']);");

          if (this.props.user && this.props.user.email) {
            sfmc_script_html = sfmc_script_html + "_etmc.push(['setUserInfo', { 'email': '".concat(this.props.user.email, "' }]);");
          }

          sfmc_script_html = sfmc_script_html + "_etmc.push([\"updateItem\",\n        {\n          \"item_type\": \"content\",\n          \"item\": \"".concat(window.location.origin + window.location.pathname, "\",\n          \"url\": \"").concat(window.location.href, "\",\n          \"available\": \"Y\",\n        },\n      ]);");
          sfmc_script_html = sfmc_script_html + "_etmc.push(['trackPageView', { \"item\" : \"".concat(window.location.origin + window.location.pathname, "\" }]);}})(window, document, 'script', 'https://").concat(this.props.sfmc_business_account_id, ".collect.igodigital.com/collect.js', '_etmc');");
          sfmc.innerHTML = sfmc_script_html;
          this.instance.appendChild(sfmc);
        }

        if (this.props.outbrain_tracking_id) {
          // Outbrain Pixel tracking
          var outbrain = document.createElement('script');
          var outbrain_script_html = "\n      !function(_window, _document) {\n        const OB_ADV_ID = '".concat(this.props.outbrain_tracking_id, "';\n        if (_window.obApi) {var toArray = function(object) {return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];};\n        _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));\n        return;\n        }\n        var api = _window.obApi = function() {api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);};\n        api.version = '1.1';\n        api.loaded = true;\n        api.marketerId = OB_ADV_ID;\n        api.queue = [];\n        var tag = _document.createElement('script');\n        tag.async = true;\n        tag.src = '//amplify.outbrain.com/cp/obtp.js';\n        tag.type = 'text/javascript';var script = _document.getElementsByTagName('script')[0];script.parentNode.insertBefore(tag, script);}(window, document);\n        obApi('track', 'PAGE_VIEW');\n      ");
          outbrain.innerHTML = outbrain_script_html;
          this.instance.appendChild(outbrain);
        }
        /* Jackmedia pixel */


        if (this.props.jackmedia_pixel_id) {
          var jackmedia_pixel = document.createElement('script');
          jackmedia_pixel.id = 'jackmedia_pixel';
          var jackmedia_pixel_html = "\n      window._tfa = window._tfa || [];\n      window._tfa.push({notify: 'event', name: 'page_view', id: ".concat(this.props.jackmedia_pixel_id, "});\n      !function (t, f, a, x) {\n      if (!document.getElementById(x)) {\n      t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);\n      }\n      }(document.createElement('script'),\n      document.getElementsByTagName('script')[0],\n      '//cdn.taboola.com/libtrc/unip/").concat(this.props.jackmedia_pixel_id, "/tfa.js',\n      'tb_tfa_script');\n    ");
          jackmedia_pixel.innerHTML = jackmedia_pixel_html;
          this.instance.appendChild(jackmedia_pixel);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        return (
          /*#__PURE__*/
          React.createElement("div", {
            "data-testid": "TrackingRegister",
            ref: function ref(el) {
              return _this.instance = el;
            }
          })
        );
      }
    }]);

    return TrackerRegistration;
  }(React.Component);

  TrackingProvider.propTypes = {
    children: PropTypes__default.node
  };
  TrackerRegistration.propTypes = {
    twitter_analytics_id: PropTypes.string,
    ga_code: PropTypes__default.string,
    bing_uet_tag_code: PropTypes__default.string,
    google_adwords_id: PropTypes__default.string,
    facebook_pixel_id: PropTypes__default.string,
    fullstory_id: PropTypes__default.string,
    zendesk_id: PropTypes__default.string,
    sfmc_business_account_id: PropTypes__default.string,
    facebook_conversion_url: PropTypes__default.string
  };
  exports.TrackerRegistration = TrackerRegistration;
  exports.TrackingProvider = TrackingProvider;
  exports.track = track;
  exports.useTracker = useTracker;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});